const Teams = {
    colors: [
        '#b8daff',
        '#c3e6cb',
        '#f5c6cb',
        '#ffeeba'
    ]
}

module.exports = Teams;